<script>


function myFunction() {
  let x = document.querySelector("#myLinks");
  if (x.style.display === "block") {
    x.style.display = "none";
  } else {
    x.style.display = "block";
  }
};



</script>

<style>

.topnav {
	width: 95%;
	display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    top: 0px;
	background-color: rgba(255,255,255,0.5);
	height: 50px;
	margin: 0 auto;
	z-index: 1001;
}

.topnav img {
	overflow: hidden;
}

#myLinks {
	display: none;
    background-color: rgba(0,0,0,0.8);
    z-index: 1002;
}

#myLinks a {
	font-family: bebas-neue-by-fontfabric,sans-serif;
	font-weight: 700;
	font-style: normal;
	color: white;
	padding: 0.5rem;
	text-decoration: none;
	font-size: 1.3rem;
	display: block;
}

#myLinks button {
    float: right;
    background-color: rgba(0,0,0,0);
    color: white;
    border: none;
}

.brand {
	float: left;
	height: 40px;
}

.menu {
	float: right;
	height: 40px;
}

</style>

<section>
	<div class="topnav">
	<a href="#home" class="brand"><img class="brand" src="pictures/Vitals_Contact Sheet_Green-01.png" alt="vitals icon"></a>
	<a href="javascript:void(0);" class="menu" on:click="{myFunction}"><img class="menu" src="pictures/menu.svg" alt="Menu"></a>
    <div id="myLinks">
		<button class="close-button" aria-label="Close alert" type="button" on:click={myFunction}>
            <span aria-hidden="true">&times;</span>
        </button> 
        <a href="#score" on:click={myFunction}>Severity Score</a>
		<a href="#triage" on:click={myFunction}>Triage</a>
		<a href="#training" on:click={myFunction}>Training</a>
		<a href="#about" on:click={myFunction}>About</a>
	</div>
</div>
</section>